import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"background-color":"#f5f5f5","margin-top":"0.7rem"} }
const _hoisted_2 = { class: "withdraw_box" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "right" }
const _hoisted_5 = { style: {"padding":"0.2rem 0.16rem 0","box-sizing":"border-box","display":"flex","justify-content":"space-between"} }
const _hoisted_6 = { style: {"font-size":"0.14rem"} }
const _hoisted_7 = { style: {"font-size":"0.24rem","color":"#c01a26"} }
const _hoisted_8 = { style: {"display":"flex","font-size":"0.14rem","color":"#333333","margin":"0.16rem 0 0.12rem"} }

import leftTemplate from "@/components/leftTemplate.vue";
import bacnkCardAdd from "@/components/card/bacnk_card_add.vue";
import gotoAuthentication from "@/components/card/gotoAuthentication.vue";
import addWithdraw from "@/components/card/addWithdraw.vue";
import { ref } from "vue";
import { ElTable } from "element-plus";
import { Axios } from "../../assets/js/ls_com_axios.js";
import axioss from "axios";
// 表格
import { serverBaseUrl } from "@/assets/js/ls_tgServerUrls.js";
interface User {
  price: string;
  time: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'withdraw',
  setup(__props) {

document.title = "标识山西-提现";
const multipleTableRef = ref<InstanceType<typeof ElTable>>();
const multipleSelection = ref<User[]>([]);
// 提现金额
const userObj = ref({});
const getInfo = () => {
  Axios("get", "/member/account-manage/info", false, false, (res) => {
    // myBankList.value = res.data.data;
    // console.log(res.data);
    userObj.value = res.data.data;
  });
};
const toggleSelection = (rows?: User[]) => {
  if (rows) {
    rows.forEach((row) => {
      multipleTableRef.value!.toggleRowSelection(row, undefined);
    });
  } else {
    multipleTableRef.value!.clearSelection();
  }
};
const handleSelectionChange = (val: User[]) => {
  multipleSelection.value = val;
};
const tableData = ref([]);
// 提现数据列表
const arraymylist = () => {
  Axios("GET", "/member/member-out/my-list", null, false, function (res: any) {
    if (res.data.code === 200) {
      tableData.value = res.data.rows;
    }
  });
};
const myBankList = ref([]);
// 获取银行卡个数
const bankNumF = () => {
  Axios("get", "/member/member-bank/my-list", false, false, (res) => {
    myBankList.value = res.data.data;
  });
};
getInfo();
arraymylist();
bankNumF();
//添加银行
let addCardVisible = ref(false);
const handleCard = () => {
  if (myBankList.value.length == 0) addCardVisible.value = true;
  else addWithdrawVisible.value = true;
};
const exportt = () => {
  axioss({
    method: "POST",
    url: serverBaseUrl + "/member/member-out/member-export",
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("token")
        ? "Bearer " + localStorage.getItem("token")
        : "",
      "Access-Control-Allow-Origin": "*",
    },
  }).then((res) => {
    const link = document.createElement("a");
    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
    link.style.display = "none";
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "提现流水.xls");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });

  // "POST", "/member/member-out/member-export", {}, false, (res) => {
  // 	console.log('res', res);

  // const link = document.createElement("a");
  // let blob = new Blob([res], { type: "application/vnd.ms-excel" });
  // link.style.display = "none";
  // link.href = URL.createObjectURL(blob);
  // link.setAttribute("download", "提现流水.xls");
  // document.body.appendChild(link);
  // link.click();
  // document.body.removeChild(link);
};
//认证
let addAuthenVisible = ref(false);
const handleAuthen = () => {
  addAuthenVisible.value = true;
};
//提现
let addWithdrawVisible = ref(false);
const onSubmit = () => {
  bankNumF();
  addCardVisible.value = false;
};
//关闭
const handleClose = (type) => {
  addWithdrawVisible.value = false;
  if (type) {
    getInfo();
    arraymylist();
    bankNumF();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(leftTemplate, { left_tabShow: 'withdraw' })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, [
                _cache[3] || (_cache[3] = _createTextVNode(" 待提现金额")),
                _createElementVNode("span", _hoisted_7, _toDisplayString(userObj.value.amount ? (userObj.value.amount / 1).toFixed(2) : 0), 1),
                _cache[4] || (_cache[4] = _createTextVNode("元 "))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", null, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", null, "已提现", -1)),
                  _createElementVNode("span", null, _toDisplayString(userObj.value.out ? (userObj.value.out / 1).toFixed(2) : 0), 1),
                  _cache[6] || (_cache[6] = _createElementVNode("span", null, "元", -1))
                ])
              ])
            ]),
            _createElementVNode("div", { style: {"display":"flex"} }, [
              _createElementVNode("div", {
                class: "withdraw_bnt",
                onClick: exportt
              }, "导出"),
              _createElementVNode("div", {
                class: "withdraw_bnt",
                style: {"background":"#2a78ff","color":"#fff","border":"none"},
                onClick: handleCard
              }, " 提现 ")
            ])
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("div", { style: {"font-size":"0.12rem","color":"#86909c","margin":"0.02rem 0","padding":"0.12rem","box-sizing":"border-box"} }, " 截止每周日账户余额 ≥ 100 元时，打款将在下周三24:00前处理，如遇法定节假日，将顺延至工作周的第一天处理（到账时间请以银行为准） ", -1)),
          _createVNode(_unref(ElTable), {
            ref_key: "multipleTableRef",
            ref: multipleTableRef,
            data: tableData.value,
            style: {"width":"100%"},
            height: "450"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "提现日期",
                align: "center",
                property: "updateTime"
              }),
              _createVNode(_component_el_table_column, {
                label: "金额",
                align: "center",
                property: "outMoney"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", null, [
                    _cache[7] || (_cache[7] = _createElementVNode("span", null, "￥", -1)),
                    _createTextVNode(_toDisplayString((scope.row.outMoney / 1).toFixed(2)), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "状态",
                align: "center",
                property: "outMoney"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_tag, {
                    type: scope.row.status == 1 ? 'success' : scope.row.status == 0 ? 'primary' : 'danger'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.status == 1 ? "提现成功" : scope.row.status == 0 ? "审核中" : "审核失败"), 1)
                    ]),
                    _: 2
                  }, 1032, ["type"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: "",
      modelValue: _unref(addAuthenVisible),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(addAuthenVisible) ? (addAuthenVisible).value = $event : addAuthenVisible = $event)),
      "align-center": "",
      width: "480px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _createVNode(gotoAuthentication)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "添加银行卡",
      modelValue: _unref(addCardVisible),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(addCardVisible) ? (addCardVisible).value = $event : addCardVisible = $event)),
      "align-center": "",
      width: "480px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _createVNode(bacnkCardAdd, { onSubmit: onSubmit })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "提现",
      modelValue: _unref(addWithdrawVisible),
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(addWithdrawVisible) ? (addWithdrawVisible).value = $event : addWithdrawVisible = $event)),
      "align-center": "",
      width: "480px",
      "before-close": handleClose,
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _createVNode(addWithdraw, {
          handleClose: handleClose,
          bankList: myBankList.value
        }, null, 8, ["bankList"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})